/**
 * Service Registry - Central DI wiring
 * Registers core singletons into the ServiceContainer so modules can
 * resolve dependencies without direct imports, reducing coupling.
 */
import container from '../core/ServiceContainer.js';
import EventBus from '../core/EventBus.js';
import actionRouter from '../core/ActionRouter.js';
import { SERVICE_TOKENS as T } from '../core/services.tokens.js';

// Core services (singletons)
import ApiService from './ApiService.js';
import StorageService from './StorageService.js';
import PromptService from './PromptService.js';
import InitiativeService from './InitiativeService.js';
import AnalyticsService from './AnalyticsService.js';
import FeedbackService from './FeedbackService.js';
import CausalGraphService from './CausalGraphService.js';

try {
  // Prefer set() for instances; factories can be added later as needed
  // Register instances under string keys and tokens
  const pairs = [
    [T.EVENTS, EventBus],
    [T.ROUTER, actionRouter],
    [T.API, ApiService],
    [T.STORAGE, StorageService],
    [T.PROMPTS, PromptService],
    [T.INITIATIVES, InitiativeService],
    [T.ANALYTICS, AnalyticsService],
    [T.FEEDBACK, FeedbackService],
    [T.CAUSALITY, CausalGraphService]
  ];
  for (const [key, inst] of pairs) {
    container.set(key, inst);
  }
  // Legacy aliases to ease migration
  container.set('events', EventBus);
  container.set('router', actionRouter);
  container.set('api', ApiService);
  container.set('storage', StorageService);
  container.set('prompts', PromptService);
  container.set('initiatives', InitiativeService);
  container.set('analytics', AnalyticsService);
  container.set('feedback', FeedbackService);
  container.set('causality', CausalGraphService);

  // Expose for legacy code that expects a global container
  if (typeof window !== 'undefined') {
    window.DIContainer = container;
    window.container = container;
  }
} catch (_) {}

export default container;
